// extracted by mini-css-extract-plugin
export default {"removeBorder":"removeBorder--XggvP","dialogBox":"dialogBox--BOdQu","description":"description--xFYWS"};